module.exports = __webpack_public_path__ + "static/img/2.d7c3233.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos-en/2.png
// module id = tYMN
// module chunks = 0